export default function defaultTranslationKeys() {
  return {
    defaultEmployeeLabel: __APP__?.DEFAULT_EMPLOYEE_LABEL || 'employee',
    defaultEmployeeLabelPlural:
      __APP__?.DEFAULT_EMPLOYEE_LABEL_PLURAL || 'employees',
    defaultEmployeeLabelLowerCase:
      __APP__?.DEFAULT_EMPLOYEE_LABEL?.toLowerCase() || 'employee',
    defaultShiftLabel: __APP__?.DEFAULT_SHIFT_LABEL || 'shift',
    defaultShiftLabelPlural: __APP__?.DEFAULT_SHIFT_LABEL_PLURAL || 'shifts',
    defaultMealBreakUnpaidLabel:
      __APP__?.DEFAULT_MEAL_BREAK_UNPAID_LABEL || 'meal break (unpaid)',
    defaultRestBreakPaidLabel:
      __APP__?.DEFAULT_REST_BREAK_PAID_LABEL || 'rest break (paid)',
  };
}
